/**
 * A route guard that checks if the user has the required permissions to access the route.
 * If the user has the required permissions, the guard allows the user to access the route.
 * If the user does not have the required permissions, the guard redirects the user to the
 * unauthorized page.
 *
 * @param permissions - An array of permissions required to access the route.
 * @param requirement - The requirement for permission. Can be one of 'all', 'some', or 'none'.
 *                      'all' means the user must have all the required permissions to access the route.
 *                      'some' means the user must have at least one of the required permissions to access the route.
 *                      'none' means the user must not have any of the required permissions to access the route.
 *
 *
 * Usage:
 * Add the permission guard to the canActivate property of a route in the routing module, along with the required
 * permissions.
 *
 * Example:
 * {
 *   path: 'admin',
 *   component: AdminComponent,
 *   canActivate: [PermissionGuard],
 *   data: { permissions: ['add-orders'], requirement: 'all' },
 * }
 *
 * In the above example, the permission guard checks if the user has the 'view-admin' or 'manage-users'
 * permission before allowing access to the AdminComponent.
 */

import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { ProfileService } from '@boma/website/shared';

@Injectable({
  providedIn: 'root',
})
// TODO CanActivate is deprecated needs to be replaced.
export class PermissionsGuard implements CanActivate {
  constructor(
    private profileService: ProfileService,
    private router: Router
  ) {}

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean | UrlTree> {
    await this.profileService.loadUserProfile();

    const permissions = next.data['permissions'] as string[];
    const requirement = next.data['requirement']
      ? next.data['requirement']
      : 'some';

    if (this.profileService.hasPermissions(permissions, requirement)) {
      console.log('true');
      return true;
    } else {
      console.log('false');
      return this.router.parseUrl('/');
    }
  }
}
